import { observer } from 'mobx-react';
import security from 'stores/security';
import IBClose from './IB';
import MarscoClose from './Marsco';
import './style.scss';

/**
 * 关闭账户
 */
const Close: React.FC = observer(() => {
    return security.isMarscoAccount ? <MarscoClose /> : <IBClose />;
});

export default Close;
